/* SPI Collection — Infinite Scroll + Custom Sort Panel */

/* ── 1. Infinite Scroll ──────────────────────────────────── */
(function () {
  'use strict';

  var container = document.querySelector('[data-infinite-scroll="true"]');
  if (!container) return;

  var sectionId = container.dataset.sectionId;
  var gridEl    = container.querySelector('#product-grid');
  // Collection: #product-grid is the <ul>. Search: #product-grid is a wrapper <div> — target the <ul> inside it.
  var grid      = gridEl && gridEl.tagName === 'UL'
    ? gridEl
    : (gridEl ? gridEl.querySelector('ul[role="list"]') : null);
  var sentinel  = container.querySelector('#SpiScrollSentinel');
  var loader    = container.querySelector('#SpiScrollLoader');

  if (!grid || !sentinel || !loader) return;

  var nextUrl    = sentinel.dataset.nextUrl || null;
  var loading    = false;
  var scrollTimer = null;

  if (!nextUrl) return;

  window.addEventListener('scroll', function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(scrollExecute, 200);
  });

  function scrollExecute() {
    if (loading || !nextUrl) return;
    var distanceFromBottom = document.documentElement.scrollHeight - 800;
    var scrolledTo         = window.scrollY + window.innerHeight;
    if (scrolledTo > distanceFromBottom) loadNextPage();
  }

  function loadNextPage() {
    loading = true;
    loader.hidden = false;

    var url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString())
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc      = new DOMParser().parseFromString(html, 'text/html');
        var newItems = doc.querySelectorAll('.grid__item');

        newItems.forEach(function (item) {
          grid.appendChild(document.adoptNode(item));
        });

        var nextSentinel = doc.querySelector('#SpiScrollSentinel');
        nextUrl = (nextSentinel && nextSentinel.dataset.nextUrl) ? nextSentinel.dataset.nextUrl : null;

        loader.hidden = true;
        loading = false;

        if (!nextUrl) {
          window.removeEventListener('scroll', scrollExecute);
          sentinel.remove();
          loader.remove();
        }
      })
      .catch(function () {
        loader.hidden = true;
        loading = false;
      });
  }
})();


/* ── 2. Custom Sort Panel ────────────────────────────────── */
(function () {
  'use strict';

  function initSortPanel() {
    document.querySelectorAll('.facet-filters__sort').forEach(function (select) {
      var field = select.closest('.facet-filters__field');
      if (!field) return;
      if (field.querySelector('.spi-sort-wrapper')) return; // already initialised
      buildSortUI(select);
    });
  }

  function buildSortUI(select) {
    var nativeWrapper = select.closest('.select');
    if (!nativeWrapper) return;

    var field = select.closest('.facet-filters__field');
    if (!field) return;

    var currentOpt  = select.options[select.selectedIndex];
    var currentText = currentOpt ? currentOpt.text : 'Sort';

    /* ── Trigger button ── */
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'spi-sort-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML =
      '<span class="spi-sort-btn__text">' + currentText + '</span>' +
      '<span class="spi-sort-btn__dot" aria-hidden="true">•</span>';

    /* ── Panel ── */
    var panel = document.createElement('div');
    panel.className = 'spi-sort-panel';

    var optionsHtml = Array.from(select.options).map(function (opt) {
      var active = opt.selected;
      return '<li class="spi-sort-panel__item' + (active ? ' spi-sort-panel__item--active' : '') + '"' +
        ' data-value="' + opt.value + '" role="option" aria-selected="' + active + '">' +
        '<span>' + opt.text + '</span>' +
        (active ? '<span class="spi-sort-panel__dot" aria-hidden="true">•</span>' : '') +
        '</li>';
    }).join('');

    panel.innerHTML =
      '<div class="spi-sort-panel__header">' +
        '<span class="spi-sort-panel__title">SORT BY</span>' +
        '<button type="button" class="spi-sort-panel__close" aria-label="Close">&#x2715;</button>' +
      '</div>' +
      '<ul class="spi-sort-panel__list" role="listbox">' + optionsHtml + '</ul>';

    /* ── Wrapper ── */
    var wrap = document.createElement('div');
    wrap.className = 'spi-sort-wrapper';
    wrap.appendChild(btn);
    wrap.appendChild(panel);

    /* Hide native select, inject custom UI */
    nativeWrapper.style.display = 'none';
    field.appendChild(wrap);

    /* ── Events ── */
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = panel.classList.toggle('spi-sort-panel--open');
      btn.setAttribute('aria-expanded', open);
    });

    panel.querySelector('.spi-sort-panel__close').addEventListener('click', function () {
      panel.classList.remove('spi-sort-panel--open');
      btn.setAttribute('aria-expanded', 'false');
    });

    panel.querySelectorAll('.spi-sort-panel__item').forEach(function (item) {
      item.addEventListener('click', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', item.dataset.value);
        window.location = url.toString();
      });
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) {
        panel.classList.remove('spi-sort-panel--open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function setup() {
    initSortPanel();

    // Re-initialise after Shopify AJAX filter re-renders the DOM
    // Watches both collection and search filter containers
    var reinitTimer = null;
    function observeContainer(id) {
      var el = document.getElementById(id);
      if (!el) return;
      new MutationObserver(function (mutations) {
        var hasAdditions = mutations.some(function (m) {
          return m.type === 'childList' && m.addedNodes.length > 0;
        });
        if (!hasAdditions) return;
        clearTimeout(reinitTimer);
        reinitTimer = setTimeout(initSortPanel, 120);
      }).observe(el, { childList: true, subtree: true });
    }
    observeContainer('main-collection-filters');
    observeContainer('main-search-filters');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

/* ── 3. Mobile filter drawer — close button ──────────────── */
(function () {
  function initDrawerClose() {
    document.querySelectorAll('.mobile-facets__close').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var details = btn.closest('details');
        if (!details) return;
        var drawer = details.closest('menu-drawer');
        if (drawer && typeof drawer.closeMenuDrawer === 'function') {
          drawer.closeMenuDrawer({ type: 'click' }, details.querySelector('summary'));
        } else {
          details.classList.remove('menu-opening');
          details.removeAttribute('open');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerClose);
  } else {
    initDrawerClose();
  }
})();

/* ── 4. Overlay gold cursor on filter drawer ─────────────── */
(function () {
  var cursor = null;

  function createCursor() {
    if (document.getElementById('spi-overlay-cursor')) return;
    cursor = document.createElement('div');
    cursor.id = 'spi-overlay-cursor';
    cursor.innerHTML = '<span>&#x2715;</span>';
    document.body.appendChild(cursor);
  }

  function closeDrawer(details) {
    var drawer = details.closest('menu-drawer');
    if (drawer && typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer({ type: 'click' }, details.querySelector('summary'));
    } else {
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
    }
  }

  function initOverlayCursor() {
    createCursor();

    document.addEventListener('mousemove', function (e) {
      var overlay = document.querySelector('.mobile-facets');
      var inner   = document.querySelector('.mobile-facets__inner');
      if (!overlay || !inner || !cursor) return;

      var isDrawerOpen = overlay.closest('details') &&
                         overlay.closest('details').classList.contains('menu-opening');
      if (!isDrawerOpen) {
        cursor.classList.remove('spi-overlay-cursor--visible');
        document.body.style.cursor = '';
        return;
      }

      var onInner = inner.contains(e.target) || inner === e.target;
      var isDesktop = window.innerWidth >= 750;
      if (onInner || !isDesktop) {
        cursor.classList.remove('spi-overlay-cursor--visible');
        document.body.style.cursor = '';
      } else {
        cursor.style.left = e.clientX + 'px';
        cursor.style.top  = e.clientY + 'px';
        cursor.classList.add('spi-overlay-cursor--visible');
        document.body.style.cursor = 'none';
      }
    });

    document.addEventListener('click', function (e) {
      var overlay = document.querySelector('.mobile-facets');
      var inner   = document.querySelector('.mobile-facets__inner');
      if (!overlay || !inner) return;

      var details = overlay.closest('details');
      if (!details || !details.classList.contains('menu-opening')) return;

      var onInner = inner.contains(e.target) || inner === e.target;
      if (!onInner) {
        document.body.style.cursor = '';
        if (cursor) cursor.classList.remove('spi-overlay-cursor--visible');
        closeDrawer(details);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOverlayCursor);
  } else {
    initOverlayCursor();
  }
})();
